import { colors } from '@insurancemenu/imenu-components-lib';
import NoDataPlaceholder from 'components/common/general/NoDataPlaceholder';
import styled from 'styled-components';

export const CartItemsListStyled = styled.div`
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

export const ProposalsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 30vh;
`;

export const ProductLineSectionStyled = styled.section`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 3.2rem 4rem 4rem;
  margin-bottom: 3.2rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const NoDataPlaceholderStyled = styled(NoDataPlaceholder)`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 5rem 4rem;
`;
